import { CancelTokenSource } from 'axios'
import { Credentials, Rr, RrPerson } from '@/commons/types'
import {
    Module,
    Action,
    VuexModule
} from 'vuex-class-modules'
import { VuexRegisterGlobals } from '@/store/decorators/vuex.register.globals'
import { ObjectUtils } from '@/commons/utils/objects'
import { DocumentResponse } from '@/commons/types/document'

@VuexRegisterGlobals({
    actionParams: [{
        targetActionName: 'clearAll',
        contextActionName: 'clear'
    }]
})
@Module({ generateMutationSetters: true })
export default class User extends VuexModule {
    rrRequestCancelToken: CancelTokenSource | null = null
    firstName = ''
    lastName = ''
    personCode = ''
    rrInfo: Rr | null = null
    validDocuments: Array<DocumentResponse> | null = null;

    get isValidRrInfo (): boolean {
        return !ObjectUtils.isEmpty(this.rrInfo)
    }

    get rrPerson (): RrPerson | null {
        if (!this.rrInfo) {
            return null
        }
        return this.rrInfo.personData
    }

    get underCareAndWardens (): Array<RrPerson> {
        if (!this.rrInfo) {
            return []
        }
        const underCareAndWardens = [
            ...this.rrInfo.underCare
        ]
        const alreadyAddedPersons = underCareAndWardens.map(rrPerson => rrPerson.personCode)
        this.rrInfo.wardens
            .filter(warden => !alreadyAddedPersons.includes(warden.personCode))
            .forEach(warden => underCareAndWardens.push(warden))
        return underCareAndWardens
    }

    @Action
    setUserInfo (userCredentials: Credentials): void {
        this.firstName = userCredentials.firstName
        this.lastName = userCredentials.lastName
        this.personCode = userCredentials.personCode
    }

    @Action
    clear (): void {
        this.rrRequestCancelToken = null
        this.firstName = ''
        this.lastName = ''
        this.personCode = ''
        this.rrInfo = null
        this.validDocuments = null
    }
}
